import { PseudoElementSelector } from "./pseudo-element.js";
/**
 * {@link https://drafts.csswg.org/css-pseudo-4/#selectordef-spelling-error}
 */
export class SpellingError extends PseudoElementSelector {
    static of() {
        return new SpellingError();
    }
    constructor() {
        super("spelling-error");
    }
    *[Symbol.iterator]() {
        yield this;
    }
}
(function (SpellingError) {
    SpellingError.parse = PseudoElementSelector.parseNonLegacy("spelling-error", SpellingError.of);
})(SpellingError || (SpellingError = {}));
//# sourceMappingURL=spelling-error.js.map